export const get = (name) =>
  function* ({ cookies }) {
    try {
      return cookies.get(name);
    } catch (e) {
      return null;
    }
  };

export const getJSON = (name) =>
  function* () {
    const string = yield get(name);

    try {
      return JSON.parse(string);
    } catch (e) {
      return null;
    }
  };

export const set = (name, value, daysToExpire, options = {}) =>
  function* ({ cookies }) {
    return cookies.set(name, value, daysToExpire, options);
  };

export const setJSON = (name, value, daysToExpire, options = {}) =>
  function* () {
    try {
      return yield set(name, JSON.stringify(value), daysToExpire, options);
    } catch (e) {
      return null;
    }
  };

export const expire = (name) =>
  function* ({ cookies }) {
    return cookies.set(name, null, -1);
  };
